// extracted by mini-css-extract-plugin
export default {"input":"AddWeeklyForm_input__UZlkh","del":"AddWeeklyForm_del__tGXVy"};